import { render, staticRenderFns } from "./TransactionsView.vue?vue&type=template&id=39b43ef4&scoped=true&"
import script from "./TransactionsView.vue?vue&type=script&lang=js&"
export * from "./TransactionsView.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsView.vue?vue&type=style&index=0&id=39b43ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b43ef4",
  null
  
)

export default component.exports